var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:["sidebar", _vm.visible ? "sidebar--visible" : ""]},[_c('share-button',{attrs:{"expanded":"","link":_vm.getLink(),"download":_vm.pdfReport}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }